import { I18n } from 'react-redux-i18n'
import { IDS_REPORT } from '../../../cartAndOrders/constant'
import { isInValidValue } from '../../../helpers/value'

export const remainingDays = (startDate, endDate) => {
  const oneDay = 24 * 60 * 60 * 1000

  const diffDays = Math.round((startDate - endDate) / oneDay)

  const getDayText = diffDays > 1 ? 'DAYS' : 'DAY'

  return `${diffDays}  ${I18n.t(`subscriptionPayment.${getDayText}`)}`
}

export const remainingMonthsAndDays = (startDate, endDate) => {
  const diff = new Date(
    endDate.getFullYear() - startDate.getFullYear(),
    endDate.getMonth() - startDate.getMonth(),
    endDate.getDate() - startDate.getDate(),
  )

  const getMonthText = diff.getMonth() > 1 ? 'MONTHS' : 'MONTH'
  const getYearText = diff.getYear() > 1 ? 'YEARS' : 'YEAR'
  const getDayText = diff.getDate() > 1 ? 'DAYS' : 'DAY'

  if (diff.getYear() === 0) {
    return `${diff.getMonth()} ${I18n.t(
      `subscriptionPayment.${getMonthText}`,
    )} ${diff.getDate()} ${I18n.t(`subscriptionPayment.${getDayText}`)}`
  }

  if (diff.getYear() === 0 && diff.getMonth() === 0) {
    return `${diff.getDate()}  ${I18n.t(`subscriptionPayment.${getDayText}`)}`
  }

  return `${diff.getYear()}  ${I18n.t(
    `subscriptionPayment.${getYearText}`,
  )} ${diff.getMonth()} ${I18n.t(
    `subscriptionPayment.${getMonthText}`,
  )} ${diff.getDate()}  ${I18n.t(`subscriptionPayment.${getDayText}`)}`
}

const getVolumeStamp = (volume, allPriceArr) => {
  if (!volume) {
    return null
  }

  let volumeStamp = null
  for (let i = 0; i < allPriceArr.length; i++) {
    volumeStamp = allPriceArr[i]
    if (allPriceArr[i] > volume) {
      break
    }
  }

  return volumeStamp
}

export const getDiscountIdtPriceByVolume = (volume, discountedPriceArr) => {
  const allPriceArr = discountedPriceArr?.map((item) => item.quantity)
  let volumeStamp = getVolumeStamp(volume, allPriceArr)
  const lastIndex = allPriceArr?.length - 1

  const discountedPriceIndex =
    volume === allPriceArr[lastIndex]
      ? lastIndex
      : discountedPriceArr?.findIndex((item) => item.quantity === volumeStamp) -
        1

  const discountedPrice =
    volume >= allPriceArr[lastIndex]
      ? 0
      : discountedPriceArr[discountedPriceIndex]
  return {
    discountId: discountedPrice?.discountId,
    discountPercentage: discountedPrice?.discountPercentage,
  }
}

export const getDiscountedPriceByVolume = (volume, discountedPriceArr) => {
  const allPriceArr = discountedPriceArr?.map((item) => item.quantity)
  let volumeStamp = getVolumeStamp(volume, allPriceArr)
  const lastIndex = allPriceArr?.length - 1

  const discountedPriceIndex =
    volume === allPriceArr[lastIndex]
      ? lastIndex
      : discountedPriceArr?.findIndex((item) => item.quantity === volumeStamp) -
        1

  const discountedPrice =
    volume >= allPriceArr[lastIndex]
      ? 0
      : discountedPriceArr[discountedPriceIndex]?.price

  return discountedPrice
}

export const getPricingPackageIdByVolume = (volume, discountedPriceArr) => {
  const allPriceArr = discountedPriceArr?.map((item) => item.quantity)
  let volumeStamp = getVolumeStamp(volume, allPriceArr)
  const lastIndex = allPriceArr?.length - 1

  const pricingPackageIdIndex =
    volume >= allPriceArr[lastIndex]
      ? lastIndex
      : discountedPriceArr?.findIndex((item) => item.quantity === volumeStamp) -
        1
  const pricingPackageId =
    discountedPriceArr[pricingPackageIdIndex]?.pricingPackageId

  return pricingPackageId
}

export const getMaxVolumeInPricingPackage = (discountedPriceArr) => {
  const allPriceArr = discountedPriceArr?.map((item) => item.quantity)
  const lastIndex = allPriceArr?.length - 1

  return allPriceArr[lastIndex]
}

export const checkInvalidInputVal = (val, isRequired = true) => {
  if (isRequired) {
    return val === undefined || val === null || val === ''
  } else return false
}

export const checkPhoneValid = (value) => {
  if (!value) return false
  const phoneNumber = /^\+?[0-9]*$/gi
  return phoneNumber.test(value)
}

export const checkEmailValid = (value, disableRequired = false) => {
  if (!value) return disableRequired
  const email = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/gi
  return email.test(value)
}

export const getSubscriptionByType = (
  listPricing,
  subscriptionType,
  subscriptionTerm,
) => {
  if (!listPricing.length) {
    return null
  }

  return (
    listPricing?.find(
      (item) =>
        item.dataPackageId === subscriptionType &&
        item.months === subscriptionTerm,
    ) ?? {}
  )
}

export const removeEmptyItem = (obj) => {
  let newObj = Object.keys(obj).reduce((acc, curr) => {
    if (
      Object.keys(obj[curr]).length > 0 ||
      (!isInValidValue(obj[curr]) &&
        typeof obj[curr] !== 'object' &&
        !Array.isArray(obj[curr]))
    )
      acc[curr] = obj[curr]

    return acc
  }, {})

  return newObj
}

export const formatPrice = (price) => (price ? price : 0)

export const checkAllValidFields = (isValidForm) => {
  if (!isValidForm) {
    return false
  }

  return Object.values(isValidForm)?.every((item) => item)
}

export const getDataReportPackage = (data = []) => {
  let objDataByIdReport = {
    [IDS_REPORT.CREDIT_BUSINESS]: [],
    [IDS_REPORT.COMPREHENSIVE_BUSINESS]: [],
    [IDS_REPORT.STANDARD_BUSINESS]: [],
    [IDS_REPORT.FIINGATE_FACTSHEET]: [],
    [IDS_REPORT.SCREENING]: [],
  }
  data.forEach((item) => {
    if (item?.fiinGateReportTypeId === IDS_REPORT.CREDIT_BUSINESS) {
      objDataByIdReport[IDS_REPORT.CREDIT_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.CREDIT_BUSINESS],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.COMPREHENSIVE_BUSINESS) {
      objDataByIdReport[IDS_REPORT.COMPREHENSIVE_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.COMPREHENSIVE_BUSINESS],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.STANDARD_BUSINESS) {
      objDataByIdReport[IDS_REPORT.STANDARD_BUSINESS] = [
        ...objDataByIdReport[IDS_REPORT.STANDARD_BUSINESS],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.FIINGATE_FACTSHEET) {
      objDataByIdReport[IDS_REPORT.FIINGATE_FACTSHEET] = [
        ...objDataByIdReport[IDS_REPORT.FIINGATE_FACTSHEET],
        item,
      ]
    }
    if (item?.fiinGateReportTypeId === IDS_REPORT.SCREENING) {
      objDataByIdReport[IDS_REPORT.SCREENING] = Array.from(
        Array(item?.numOfCompanies).keys(),
      )
    }
  })

  return objDataByIdReport
}

export const getDataItemByRowId = (data, rowId) => {
  return data?.find((item) => item.id === rowId) || {}
}

export const getOrderType = (orderData) => {
  if (!orderData) return

  if (
    orderData?.hasOwnProperty('package') &&
    orderData?.hasOwnProperty('subscription')
  )
    return 'BothSNP'

  if (orderData?.hasOwnProperty('package')) return 'Package'
  if (orderData?.hasOwnProperty('subscription')) return 'Subscription'

  return 'Report'
}
